import { memo } from 'react'
import cn from 'classnames'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getModifierGroups } from 'store/Categories/selectors'
import { Img } from 'react-image'

import Loader from 'components/Loader'
import Checkbox from 'components/Checkbox'

import IconEmptyImage from 'assets/icons/IconEmptyImage.png'
import { ReactComponent as IconModifier } from 'assets/icons/IconModifier.svg'
import { createItemImageUrl } from 'utils/items/createItemImageUrl'

const Item = memo(({ item, handleSelectItem, checked, isModal }) => {
  const history = useHistory()

  const modifierGroups = useSelector(getModifierGroups)
  const modifierGroupsUuids = modifierGroups?.map(
    (modifierGroup) => modifierGroup?.uuid
  )

  const availabilityOptions = {
    available: 'Available',
    low_on_inventory: 'Low On Inventory',
    unavailable: 'Unavailable',
  }

  const {
    uuid,
    name,
    price,
    productSku,
    inventoryState,
    itemCategoryUuids,
  } = item

  const itemStateOnInventoryFormatted =
    availabilityOptions[inventoryState]
  const convertToNumberPrice = Number(price)
  const itemClassNames = cn('item', {
    '-selected': checked,
  })

  const isModifier =
    itemCategoryUuids?.some((itemCategoryUuid) =>
      modifierGroupsUuids?.includes(itemCategoryUuid)
    ) ?? false

  return (
    <div className={itemClassNames}>
      <Checkbox
        checked={checked}
        onChange={() => handleSelectItem(checked, uuid)}
      />
      <div
        className="row"
        onClick={() => {
          history.push({ state: { itemUuid: uuid } })
        }}
      >
        <div className="item-info-wrapper">
          <span className="name font-weight-bold d-flex align-items-center justify-content-space-between w-100">
            <span>{name}</span>
            <span className="d-flex padding-bottom-smalest margin-left-xs margin-right-base">
              {isModifier && <IconModifier />}
            </span>
          </span>
        </div>
        <div className="item-info-wrapper">
          <Img
            className="item__image -empty-image"
            decode={true}
            src={[createItemImageUrl(productSku), IconEmptyImage]}
            loader={!isModal && <Loader />}
          />
        </div>
        <div className="item-info-wrapper">
          {convertToNumberPrice.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          })}
        </div>
        <div className="item-info-wrapper">{productSku}</div>
        <div className="item-info-wrapper">
          <span
            className={cn({
              'item-info-wrapper__available':
                inventoryState === 'available',
              'item-info-wrapper__low':
                inventoryState === 'low_on_inventory',
              'item-info-wrapper__unavailable':
                inventoryState === 'unavailable',
            })}
          ></span>
          {itemStateOnInventoryFormatted}
        </div>
      </div>
    </div>
  )
})

export default Item
